// Cortex's access companion of a project's own web page (@cortex/app-shell): the access SDK's Access page (ADR 0066)
// wired to the app shell — the SDK's client at `/api/access` on the app's origin with the shell's session. The shell
// offers the page to the app's admins only (its speed dial's "Access"); the page itself tells anyone else that only
// admins manage people.
import { pageApp, sdkClientOptions, type AppCompanion } from '@cortex/app-shell';
import { createAccessClient, type AccessClient } from '@cortex/sdk-access-client';
import { AccessHostProvider, AccessPage, type AccessHost } from '@cortex/sdk-access-react';
import * as React from 'react';

/** The SDK's client: the shell's origin and session, under the app's mount of the SDK (`/api/<module>`). */
export function accessClient(): AccessClient {
  const o = sdkClientOptions();
  return createAccessClient({ ...o, baseUrl: `${o.baseUrl}/api/access` });
}

function AccessRoute() {
  const { slug } = pageApp();
  const host = React.useMemo<AccessHost>(() => ({ client: accessClient(), scope: slug }), [slug]);
  return (
    <AccessHostProvider host={host}>
      <AccessPage />
    </AccessHostProvider>
  );
}

export const appCompanion: AppCompanion = {
  module: 'access',
  pages: { access: async () => AccessRoute },
};
